export const TEST_ID = 'highlightTab';
